<script>
/**
 * ****************************************************************************
 * @description     :   EmptyLayout
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Best Security
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * import template
 */
import template from './template.html';

/**
 * import component
 */
import HeaderError from '@/components/headerError';
import Loading from '@/components/loading';

/**
 * Define main layout
 */
export default {
    name: 'EmptyLayout',
    template: template,
    components: {
        HeaderError,
        Loading
    }
};
</script>
